import React from 'react'
import Footer from '../Footer'
import RogerOne from '../RogerOne'

function Roger1() {
    window.scrollTo(0,0);
    return (
        <div>
            <RogerOne/>
            <Footer/>
        </div>
    )
}

export default Roger1
